import { render, staticRenderFns } from "./PengirimanView.vue?vue&type=template&id=4aa26f93&"
import script from "./PengirimanView.vue?vue&type=script&lang=js&"
export * from "./PengirimanView.vue?vue&type=script&lang=js&"
import style0 from "./PengirimanView.vue?vue&type=style&index=0&id=4aa26f93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports